import React from 'react';
import { Button, ConfirmModal, Copy, Modal } from '../../../components';
import { useVaultSecret } from '../hooks/useVaultSecret';

type VaultSecretProps = {
  agentId: string;
};

export const VaultSecret: React.FC<VaultSecretProps> = ({ agentId }) => {
  const {
    generateVaultApiSecret,
    generatingVaultSecret,
    onCloseSecretModal,
    isOpenedSecretModal,
    onCloseConfirmModal,
    isOpenedConfirm,
    onOpenConfirmModal,
    vaulSecret,
    setVaultSecret,
  } = useVaultSecret(agentId);

  const handleCancel = () => onCloseConfirmModal();

  const handleConfirm = () => {
    generateVaultApiSecret();
  };

  const handleCloseSecretModal = () => {
    onCloseSecretModal();
    setVaultSecret(null);
  };

  return (
    <>
      <ConfirmModal
        open={isOpenedConfirm}
        title="Generate API key"
        onClose={handleCancel}
        onConfirm={handleConfirm}
        saving={generatingVaultSecret}
        confirmButtonClassName="w-full bg-primary hover:bg-primary-dark border border-primary text-contrast"
        confirmButtonLabel={
          generatingVaultSecret ? 'Generating...' : 'Generate'
        }
      >
        <div className="flex flex-col gap-y-md justify-center items-center mt-md">
          <p className="text-center text-2xl">
            Are you sure you want to generate a new API key? This action cannot
            be undone.
          </p>
        </div>
      </ConfirmModal>
      <Modal
        size="small"
        open={isOpenedSecretModal}
        onClose={handleCloseSecretModal}
        title="Generated API key"
      >
        <div className="flex flex-col">
          <div className="flex flex-row gap-x-md justify-end">
            <Copy
              label="Copy key"
              className="text-buttonPrimary text-tiny"
              text={vaulSecret || ''}
            />
          </div>
          <div className="flex flex-col gap-y-md justify-center items-center my-md">
            <p className="text-center text-xl">{vaulSecret}</p>
          </div>
        </div>
        <div className="flex flex-row justify-center">
          <Button
            size="medium"
            type="contrast"
            label="Close"
            onClick={handleCloseSecretModal}
          />
        </div>
      </Modal>
      <Button
        size="medium"
        type="primary"
        label="Generate new API key"
        onClick={onOpenConfirmModal}
      />
    </>
  );
};
